import {Component} from '@angular/core';

@Component({
  selector: 'app-circle-home-icon',
  templateUrl: './circle-home-icon.component.html'
})
export class CircleHomeIconComponent {
}
